<template>
  <div class="matches">
    <header-bar></header-bar>

    <section class="instructions background-image" v-if="!uiHideInstructions">
      <div class="grid-container">
        <div class="col-4">
          <div class="vertical-align">
            <h3>You&#39;ve been matched with these people based on focus areas, skills and regions of interest.</h3>
            <a class="link-simple" @click="hideInstructions">Close</a>
          </div>
        </div>
      </div>
    </section>
    <section class="filter" v-bind:class="{ noinstructions: uiHideInstructions }">
      <div class="grid-container">
        <p>Ordered By Most Recent</p>
      </div>
    </section>
    <section class="matches">
      <div class="grid-container">

        <div class="row" v-for="row in chunkArray">
          <user-box v-for="user, key in row" :userid="user" :key="key"></user-box>
        </div>

      </div>
    </section>

  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'
import UserBox from '@/components/UserBox'

export default {
  name: 'Matches',
  props: ['personality'],
  components: {
    HeaderBar,
    UserBox
  },
  data () {
    return {
      matches: {}
    }
  },
  firebase: function () {
    return {
      fbUsers: {
        source: db.ref('users/'),
        asObject: false
      }
    }
  },
  computed: {
    uiHideInstructions: function () {
      if (this.$root.profile['ui-meta']) {
        if (this.$root.profile['ui-meta'].hideMatchesInstructions) {
          return true
        }
      } else {
        return false
      }
    },
    matchedUsers: function () {
      // Let it load
      if (!this.personality) {
        return []
      } else {
        let arr = []

        let wantSkills = this.personality['want-skills']
        let haveSkills = this.personality['have-skills']
        let focusAreas = this.personality['focus-areas']

        this.matchCheck(wantSkills, 'skills', 20)
        this.matchCheck(haveSkills, 'skills', 10)
        this.matchCheck(focusAreas, 'focus-areas', 5)

        // Count the object
        let len = 0

        // eslint-disable-next-line
        for (let o in this.matches) {
          len++
        }

        // If less than 8 matches, pick X random users.
        if (len < 8) {
          let extras = 8 - len
          this.extraUsers(extras, 1)
        }

        for (let item in this.matches) {
          // Ignore if current user
          if (item !== this.$root.user.uid) {
            arr.push(item)
          }
        }

        return arr
      }
    },
    chunkArray: function () {
      let chunks = []
      let arr = this.matchedUsers
      let i
      let chunkSize = 4

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize))
      }
      chunks.length = 3
      return chunks
    }
  },
  methods: {
    hideInstructions () {
      db.ref('users/' + this.$root.user.uid + '/ui-meta').update({
        hideMatchesInstructions: true
      }, function () {
        console.log('hidden the instructions')
      })
    },
    matchCheck (items, dbSection, points) {
      for (let attrId in items) {
        let parent = this

        // attrId is the unique ID of the skill/focus-area
        let ref = db.ref('attributes/' + dbSection + '/' + attrId + '/users')

        return ref.once('value').then(function (s) {
          // s = the list of users with that skill/focus-area
          s.forEach(function (user) {
            let uid = user.key
            if (!parent.matches[uid]) { parent.matches[uid] = 0 } // Add that uid to matches
            parent.matches[uid] = parent.matches[uid] + points // Increase by points
          })
        })
      }
    },
    extraUsers (noOfExtras, points) {
      let parent = this
      let ref = db.ref('users/')

      return ref.limitToFirst(noOfExtras).once('value').then(function (s) {
        // s = the list of users with that skill/focus-area
        s.forEach(function (user) {
          let uid = user.key
          if (!parent.matches[uid]) { parent.matches[uid] = 0 } // Add that uid to matches
          parent.matches[uid] = parent.matches[uid] + points // Increase by points
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Matches.vue?3d7cb25e